// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xLZ8","index":"styles_index__GLH-x"};